import { everything } from '@sejazipper/layer-api-client';
import { computed, reactive } from '@vue/composition-api';
import { useZipperApi } from './useZipperApi';

export const useShopsStats = () => {
  const { client } = useZipperApi();

  const state = reactive({
    eventsResults: {},
    conversionsByStoreId: [],
    loading: false,
    error: {
      load: null,
    },
  });

  const load = async (customerId, storeIds, year, month) => {
    try {
      state.loading = true;

      const [results, conversions] = await Promise.all([
        client.chain.query
          .getShopsResultsByStoreIdsAndMonth({
            customerId, storeIds, month: `${year}-${month + 1}`,
          })
          .get({ ...everything, events: { ...everything }, __typename: false }),
        client.chain.query
          .getShopsConversionByStoreIdsAndMonth({
            customerId, storeIds, month: `${year}-${month + 1}`,
          })
          .get({ ...everything, __typename: false }),
      ]);

      const unifiedResults = {
        pageView: 0,
        viewProduct: 0,
        addCart: 0,
        checkout: 0,
      };

      results.forEach(({ events }) => {
        unifiedResults.pageView += events.pageView;
        unifiedResults.viewProduct += events.viewProduct;
        unifiedResults.addCart += events.addCart;
        unifiedResults.checkout += events.checkout;
      });

      state.eventsResults = unifiedResults;
      state.conversionsByStoreId = conversions;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      state.error.load = e;
    } finally {
      state.loading = false;
    }
  };

  return {
    load,
    eventsResults: computed(() => state.eventsResults),
    conversionsByStoreId: computed(() => state.conversionsByStoreId),
    loading: computed(() => state.loading),
  };
};
